import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import PurchaseCostHistoryContainer from "@/screens/Pricing/containers/PurchaseCostHistoryContainer"
import { purchaseCostHistorySearchSchema } from "@/screens/Pricing/types/searchParams"

export const Route = createFileRoute("/app/pricing/_layout/history/purchase-cost")({
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.PRICING_VIEW,
        PermissionActionType.PRICING_MANAGER,
        PermissionActionType.PRICING_MAINTENANCE,
      ]}
    >
      <PurchaseCostHistoryContainer />
    </PermissionContentWrapper>
  ),
  validateSearch: zodValidator(purchaseCostHistorySearchSchema),
})
